/*
 * Copyright (c) 2021, salesforce.com, inc.
 * All rights reserved.
 * SPDX-License-Identifier: BSD-3-Clause
 * For full license text, see the LICENSE file in the repo root or https://opensource.org/licenses/BSD-3-Clause
 */
import SwatchGroup from '@salesforce/retail-react-app/app/theme/components/project/swatch-group'

export default {
    ...SwatchGroup,
    variants: {
        circle: (props) => {
            const originalCircle = SwatchGroup.variants.circle(props)
            return {
                ...originalCircle,
                swatch: {
                    ...originalCircle.swatch,
                    width: props.ispdp ? '37px' : '20px',
                    minWidth: props.selected
                        ? props.ispdp
                            ? '37px'
                            : '10px'
                        : props.ispdp
                        ? '37px'
                        : '20px',
                    height: props.ispdp ? '37px' : '20px',
                    _before: {
                        ...originalCircle.swatch._before,
                        height: props.selected
                            ? props.ispdp
                                ? '31px'
                                : 5
                            : props.ispdp
                            ? '31px'
                            : 3,
                        zIndex: 0,
                        left: props?.selected
                            ? props.ispdp
                                ? '18px'
                                : '8.5px'
                            : props.ispdp
                            ? '18px'
                            : '10px',
                        top: props?.selected
                            ? props.ispdp
                                ? '3px'
                                : '-1px'
                            : props.ispdp
                            ? '3px'
                            : '5px',
                        backgroundColor: 'gray.750'
                    },
                    _hover: {},
                    marginRight: props.ispdp ? '15px' : 0,
                    marginBottom: props.ispdp ? 0 : 0,
                    marginTop: props.ispdp ? '20px' : 0,
                    backgroundColor: 'transparent'
                },
                swatchButton: {
                    ...originalCircle.swatchButton,
                    width: props.selected
                        ? props.ispdp
                            ? '31px'
                            : '10px'
                        : props.ispdp
                        ? '35px'
                        : '14px',
                    minWidth: props.selected
                        ? props.ispdp
                            ? '31px'
                            : '10px'
                        : props.ispdp
                        ? '35px'
                        : '14px',
                    height: props.selected
                        ? props.ispdp
                            ? '31px'
                            : '10px'
                        : props.ispdp
                        ? '35px'
                        : '14px'
                }
            }
        },
        square: (props) => {
            const originalSquare = SwatchGroup.variants.square(props)
            return {
                ...originalSquare,
                swatch: {
                    ...originalSquare.swatch,
                    marginRight: props.ispdp ? '15px' : '10px',
                    marginBottom: props.ispdp ? 0 : 0,
                    marginTop: props.ispdp ? '20px' : '10px',
                    fontWeight: props.ispdp ? '300' : '400',
                    letterSpacing: props.ispdp ? '1px' : 'unset',
                    borderColor: props.disabled ? 'gray.500' : 'transparent',
                    width: 'fit-content',
                    minWidth: props.ispdp ? '45px' : '39px',
                    height: props.ispdp ? '45px' : '39px',
                    backgroundColor:
                        props.disabled && props.selected
                            ? 'black.100'
                            : props.disabled
                            ? 'gray.40'
                            : props.selected
                            ? 'black.100'
                            : 'gray.400',
                    color: props.disabled ? 'gray.600' : props.selected ? 'white' : 'black.100',
                    ...(props.ispdp
                        ? {}
                        : {
                              overflow: 'hidden'
                          }),
                    _active: {
                        background: 'black.100',
                        color: 'white',
                        border: 'none',
                        _hover: {
                            backgroundColor: 'black.100 !important',
                            color: 'white !important',
                            border: 'none'
                        }
                    },
                    backgroundImage: 'none',
                    // Commented until clarified if OOS should be clickable or no YR-272 AC#5
                    // pointerEvents: props.disabled ? 'none' : 'auto',
                    _before: {
                        content: '""',
                        display: `${props.disabled ? 'block' : 'none'}`,
                        position: 'absolute',
                        height: props.ispdp ? '60px' : '56px',
                        width: '1px',
                        transform: props.ispdp ? 'rotate(45deg)' : 'rotate(45deg)',
                        backgroundColor: 'gray.600',
                        zIndex: 1,
                        ...(props.ispdp
                            ? {}
                            : {
                                  left: '50%',
                                  top: '-25%'
                              })
                    }
                }
            }
        }
    }
}
